import {useConfig} from '@aboutyou/config';
import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {Redirect} from '@aboutyou/router';
import React from 'react';
import {useLocation} from 'react-router';

const redirectPaths = [
  '/kolofon',
  '/personvernretningslinjer',
  '/cp/takk-norway-116145',
  '/cp/takk-norway-106121',
];

export const useShopExitRedirect = () => {
  const {isActive} = useIsFeatureActive('enable_country_exit');
  const {locale, environment} = useConfig();
  const customPageId = environment === 'production' ? '106121' : '116145';
  const globalShopUrl = `https://www.aboutyou${
    environment !== 'production' ? '-staging' : ''
  }.com/cp/see-you-global-${customPageId}?force-global=1&force-language=1`;

  if (isActive) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const location = useLocation();
    if (!redirectPaths.includes(location.pathname)) {
      return {
        isActive,
        redirect: (
          <Redirect
            to={
              locale === 'no_NO'
                ? `/cp/takk-norway-${customPageId}`
                : globalShopUrl
            }
            keepSearch={false}
            statusCode={301}
          />
        ),
      };
    }
  }
  return {isActive, redirect: null};
};
